import { render } from "./filtroCalendarioVacinacao.vue?vue&type=template&id=1b19902a&scoped=true"
import script from "./filtroCalendarioVacinacao.vue?vue&type=script&lang=js"
export * from "./filtroCalendarioVacinacao.vue?vue&type=script&lang=js"

import "./filtroCalendarioVacinacao.vue?vue&type=style&index=0&id=1b19902a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b19902a"]])

export default __exports__